// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDZ2yI2F0ceUaL06MuNLg7tvGVR9eU_NsA",
  authDomain: "keystate-95b1e.firebaseapp.com",
  projectId: "keystate-95b1e",
  storageBucket: "keystate-95b1e.appspot.com",
  messagingSenderId: "786395403065",
  appId: "1:786395403065:web:49f87a7060217079c40ee8"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);